import React, { useContext } from 'react';
import { LanguageContext } from "../context/LanguageContext";
import { GERMAN } from "../actions/language";
import PageHero from "./common/PageHero";
import CtaBand from "./common/CtaBand";

const OfficeService = () => {
    const { language } = useContext(LanguageContext);
    const de = language === GERMAN;

    const features = [
        {
            icon: 'fas fa-folder-open',
            title: de ? 'Vorbereitung für den Steuerberater' : 'Preparação para o consultor fiscal',
            text: de
                ? 'Strukturiert, sorgfältig und termingerecht: Wir sortieren Belege, erstellen Auswertungen und bereiten Ihre Finanzunterlagen digital auf – damit beim Steuerberater alles reibungslos läuft.'
                : 'Estruturada, cuidadosa e atempada: organizamos recibos, criamos análises e preparamos digitalmente os seus documentos financeiros – para que tudo corra bem com o consultor fiscal.'
        },
        {
            icon: 'fas fa-coins',
            title: de ? 'Lohnbuchhaltung' : 'Contabilidade salarial',
            text: de
                ? 'Vom Erfassen der Arbeitszeiten bis zur Gehaltsabrechnung: Ihre Mitarbeitenden werden pünktlich und korrekt bezahlt – unter Berücksichtigung aller gesetzlichen Anforderungen und aktueller Änderungen im Arbeitsrecht.'
                : 'Do registo das horas de trabalho à folha de vencimento: os seus colaboradores são pagos correta e pontualmente – cumprindo todos os requisitos legais e as alterações da legislação laboral.'
        },
        {
            icon: 'fas fa-globe-europe',
            title: de ? 'Internationales Steuerwesen' : 'Fiscalidade internacional',
            text: de
                ? 'Für komplexe steuerliche Fragestellungen arbeiten wir eng mit einer erfahrenen Steuerberaterin zusammen, die auf internationales Steuerwesen spezialisiert ist – auch grenzüberschreitende Sachverhalte sind bei uns in besten Händen.'
                : 'Para questões fiscais complexas, trabalhamos em estreita colaboração com uma consultora fiscal experiente, especializada em fiscalidade internacional – mesmo as questões transfronteiriças estão em boas mãos.'
        },
        {
            icon: 'fas fa-balance-scale',
            title: de ? 'Rechtliche Unterstützung' : 'Apoio jurídico',
            text: de
                ? 'Wir kooperieren mit einem Fachanwalt für Steuer- und Finanzrecht, der Ihnen als kompetenter Berater oder als Vertreter Ihrer Interessen zur Seite steht.'
                : 'Colaboramos com um advogado especialista em direito fiscal e financeiro, que o assiste como consultor competente ou como representante dos seus interesses.'
        }
    ];

    return (
        <main>
            <PageHero
                eyebrow={de ? 'Leistung 01 — Büroservice' : 'Serviço 01 — Escritório'}
                title={de
                    ? <span>Ihre Entlastung im <em>Büroalltag</em>.</span>
                    : <span>O seu alívio no <em>dia a dia do escritório</em>.</span>}
                lede={de
                    ? 'Unser Büroservice bietet Ihnen die perfekte Unterstützung, damit Sie sich auf Ihr Kerngeschäft konzentrieren können. Sie sparen Zeit, reduzieren den administrativen Aufwand und gewinnen die Sicherheit, dass Ihre Unterlagen professionell bearbeitet werden.'
                    : 'O nosso serviço de escritório oferece-lhe o apoio perfeito para que se possa concentrar na sua atividade principal. Poupa tempo, reduz a carga administrativa e ganha a certeza de que os seus documentos são tratados profissionalmente.'}
            />

            <section className="tm-section">
                <div className="tm-container">
                    <div className="tm-section__head">
                        <span className="tm-eyebrow">{de ? 'Was wir übernehmen' : 'O que assumimos'}</span>
                        <h2 className="tm-section__title">
                            {de
                                ? <span>Vier Bausteine für <em>reibungslose Abläufe</em>.</span>
                                : <span>Quatro pilares para <em>processos sem fricção</em>.</span>}
                        </h2>
                    </div>
                    <div className="tm-features">
                        {features.map((f, i) => (
                            <div key={i} className="tm-feature">
                                <span className="tm-feature__icon"><i className={f.icon}/></span>
                                <h3>{f.title}</h3>
                                <p>{f.text}</p>
                            </div>
                        ))}
                    </div>

                    <div className="tm-callout" style={{ marginTop: "56px" }}>
                        <i className="fas fa-shield-alt"/>
                        <div>
                            <h3>{de ? 'Kompetenz durch starke Partnerschaften' : 'Competência através de parcerias sólidas'}</h3>
                            <p>
                                {de
                                    ? 'Durch die Zusammenarbeit mit Steuerberaterin und Fachanwalt profitieren Sie von einer umfassenden Unterstützung, die weit über den klassischen Büroservice hinausgeht. Verlassen Sie sich auf unser Team und unsere Partner – wir sind für Sie da, wenn es darauf ankommt.'
                                    : 'Graças à colaboração com consultora fiscal e advogado especialista, beneficia de um apoio abrangente que vai muito além do serviço clássico de escritório. Confie na nossa equipa e nos nossos parceiros – estamos lá quando é preciso.'}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <CtaBand/>
        </main>
    );
};

export default OfficeService;



// WEBPACK FOOTER //
// ./src/components/OfficeService.js